export default "__VITE_ASSET__6cc4b969__"